module.exports = __webpack_public_path__ + "img/qrCode.4408be0b.png";